/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsUpDownToLines: {
  name: 'arrows-up-down-to-lines';
  data: string;
} = {
  name: 'arrows-up-down-to-lines',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1A.5.5 0 0 1 1 .5h14a.5.5 0 0 1 0 1H1A.5.5 0 0 1 .5 1Zm0 14a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5ZM8.354 3.646a.5.5 0 0 0-.708 0l-2 2a.5.5 0 1 0 .708.708L7.5 5.207v5.586L6.354 9.646a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.793V5.207l1.146 1.147a.5.5 0 0 0 .708-.708l-2-2Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
